module.exports = __webpack_public_path__ + "media/images/fitness_hub-9a3400dd.jpg";